import getRequest from "@/interface/index";
import i18n from "./i18n";

const createBaseRoutes = () => [
  {
    path: "/main",
    name: i18n.t("route.main"),
    component: resolve => require(["@/views/Index.vue"], resolve),
    meta: { title: i18n.t("route.main"), auth: true, keepAlive: true },
    children: [
      {
        path: "/main",
        name: i18n.t("route.index"),
        component: resolve => require(["@/views/Main.vue"], resolve),
        meta: {
          title: i18n.t("route.index"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/user/info",
        name: i18n.t("route.userInfo"),
        component: resolve => require(["@/views/other/UserInfo.vue"], resolve),
        meta: {
          title: i18n.t("route.userInfo"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/dictionary-data/:codesId/:dictType",
        name: i18n.t("route.dictData"),
        component: resolve => require(["@/views/system/DictionaryData.vue"], resolve),
        meta: {
          title: i18n.t("route.dictData"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/myapps/adver/desktop",
        name: i18n.t("myApps.ggtf"),
        component: resolve => require(["@/views/myapps/adver/Desktop"], resolve),
        meta: {
          title: i18n.t("myApps.ggtf"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/myapps/theme/list",
        name: i18n.t("theme.title"),
        component: resolve => require(["@/views/myapps/theme/list"], resolve),
        meta: {
          title: i18n.t("theme.title"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/upgrade/list/applist",
        name: i18n.t("upgrade.appList"),
        component: resolve => require(["@/views/upgrade/list/applist"], resolve),
        meta: {
          title: i18n.t("upgrade.appList"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/upgrade/apk",
        name: i18n.t("upgrade.apkList"),
        component: resolve => require(["@/views/upgrade/Apk"], resolve),
        meta: {
          title: i18n.t("upgrade.appList"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/myapps/payment/index",
        name: i18n.t("myApps.shoukuantitle"),
        component: resolve => require(["@/views/myapps/payment/index"], resolve),
        meta: {
          title: i18n.t("myApps.shoukuantitle"),
          auth: true,
          keepAlive: true
        }
      }
    ]
  }
];

const initMenu = (router, store) => {
  if (store.state.dynamicRoutesReady) {
    return false;
  }
  getRequest.request("system/listForMenu", "GET").then(res => {
    if (res && res.code === 0) {
      if (res.data && res.data.menu && res.data.menu.length > 0) {
        store.dispatch("initMenuList", res.data);
        const fmRoutes = formatRoutes(res.data.menu);
        router.addRoutes(fmRoutes);
      } else {
        // 没有菜单则跳转到登录页
        router.push("/login");
      }
    }
  });
};

const formatRoutes = routes => {
  const fmRoutes = createBaseRoutes();
  const routeKeys = new Set(
    fmRoutes[0].children.map(route => `${route.name}::${route.path}`)
  );
  if (routes && routes.length > 0) {
    for (let i = 0; i < routes.length; i++) {
      setRoutes(routes[i], fmRoutes, routeKeys);
    }
  }
  return fmRoutes;
};

const routers = route => {
  const routePath = route.path + "/" + url(route.component);
  return {
    path: routePath,
    component: resolve => require(["@/views" + route.path + "/" + route.component + ".vue"], resolve),
    name: routePath,
    icon: route.icon,
    meta: {
      ...(route.meta || {}),
      title: (route.meta && route.meta.title) || route.name
    }
  };
};

const appendRoute = (route, fmRoutes, routeKeys) => {
  const newRoute = routers(route);
  const routeKey = `${newRoute.name}::${newRoute.path}`;
  if (routeKeys.has(routeKey)) {
    return;
  }
  routeKeys.add(routeKey);
  fmRoutes[0].children.push(newRoute);
};

const setRoutes = (routes, fmRoutes, routeKeys) => {
  let children = routes.children;
  if (children && children.length > 0) {
    for (let i = 0; i < children.length; i++) {
      let child = children[i];
      if (child && child.component) {
        appendRoute(child, fmRoutes, routeKeys);
      }
      if (child && child.children) {
        setRoutes(child, fmRoutes, routeKeys);
      }
    }
  } else {
    appendRoute(routes, fmRoutes, routeKeys);
  }
};

const url = component => {
  if (component) {
    component = component.replace(component[0], component[0].toLowerCase());
    return component.replace(/([A-Z])/g, "-$1").toLowerCase();
  }
};

export default {
  initMenu,
  formatRoutes
};
